/** @format */

import { Grid } from '@material-ui/core';
import { useEffect, useState, useRef } from 'react';
import { flushSync } from 'react-dom';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { Redirect } from 'react-router';
import { Button } from 'src/components';
import Breadcrumb from 'src/components/Breadcrumb';
import Page from 'src/components/Page';
import useQuery from 'src/hooks/useQuery';
import { useDispatch, useSelector } from 'src/store';
import { getNewsArticles } from 'src/slices/news';
import { NewsItem, NewsListSkeleton } from 'src/components/news/item';
import { NewsSearch } from 'src/components/news/search';

const startViewTransition = callback => {
  if (document.startViewTransition) {
    document.startViewTransition(() => {
      flushSync(callback);
    });
  } else {
    callback();
  }
};

export default function NewsPage() {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const query = useQuery().get('query');
  const { t } = useTranslation();
  const { error, newsArticles, newsArticlesLoading } = useSelector(state => state.news);
  const [displayedContent, setDisplayedContent] = useState({ loading: true, articles: newsArticles, error: null });
  const prevLoadingRef = useRef(newsArticlesLoading);

  useEffect(() => {
    dispatch(
      getNewsArticles({
        query: query || ''
      })
    );
  }, [query, dispatch]);

  useEffect(() => {
    const wasLoading = prevLoadingRef.current;
    prevLoadingRef.current = newsArticlesLoading;

    if (wasLoading && !newsArticlesLoading) {
      startViewTransition(() => {
        setDisplayedContent({ loading: false, articles: newsArticles, error });
      });
    } else if (newsArticlesLoading && !wasLoading) {
      setDisplayedContent({ loading: true, articles: newsArticles, error: null });
    } else if (!newsArticlesLoading) {
      setDisplayedContent({ loading: false, articles: newsArticles, error });
    }

    return () => {};
  }, [newsArticlesLoading, newsArticles, error]);

  const pageTitle = t('news.title');

  return (
    <Page className={`archive-page news-page`} title={pageTitle}>
      <Breadcrumb data={[{ title: pageTitle }]} additionClassName="container-narrow" />
      <Grid className="archive-page-container container container-narrow">
        <Grid className="archive-page-title-box news-page-title-box">
          <h1 className="archive-page-title news-page-title">{pageTitle}</h1>
          <NewsSearch />
        </Grid>
        {/* <p className="news-page-description">{t('news.description')}</p> */}

        <Grid className="news-list archive-page-list" style={{ viewTransitionName: 'news-list' }}>
          {displayedContent.error ? (
            <p>{t('errorpage.text')}</p>
          ) : displayedContent.loading && displayedContent.articles?.length > 0 ? (
            <div
              style={{
                opacity: 0.2,
                transition: 'opacity 180ms ease-in-out',
                pointerEvents: 'none',
                cursor: 'not-allowed'
              }}
            >
              {displayedContent.articles.map(item => (
                <NewsItem item={item} key={item.nid} />
              ))}
            </div>
          ) : displayedContent.loading ? (
            <NewsListSkeleton count={3} />
          ) : displayedContent.articles?.length > 0 ? (
            displayedContent.articles.map(item => <NewsItem item={item} key={item.nid} />)
          ) : (
            <p className="news-list-empty">{t('news.noResults')}</p>
          )}
        </Grid>
        <Button onClick={() => history.push(`/dashboard`)} borderOnly noArrow secondary label={t('backPreviousPage')} />
      </Grid>
    </Page>
  );
}
